export const REMOTE_SERVER_URL = "wss://instore-server.onrender.com";
export const LOCAL_SERVER_URL = `ws://${location.hostname}:3000`;

const DEFAULT_SERVER_URL = REMOTE_SERVER_URL;

export const getServerUrl = (type: "musician" | "conductor", url = DEFAULT_SERVER_URL) => {
  return `${url}?type=${type}`;
};
